import React from 'react';
import { Hero } from './Hero';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { UniqueMechanism } from './UniqueMechanism';
import { Contents } from './Contents';
import { SevenDayPlan } from './SevenDayPlan';
import { Bonuses } from './Bonuses';
import { Objections } from './Objections';
import { SocialProof } from './SocialProof';
import { Pricing } from './Pricing';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
export function CleanLander() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-brand-pink selection:text-brand-dark pt-[72px]" data-id="element-70">
      <Hero data-id="element-71" />
      <Problem data-id="element-72" />
      <Solution data-id="element-73" />
      <UniqueMechanism data-id="element-74" />
      <Contents data-id="element-75" />
      <SevenDayPlan data-id="element-76" />
      <Bonuses data-id="element-77" />
      <Objections data-id="element-78" />
      <SocialProof data-id="element-79" />
      <Pricing upsellAcceptUrl="https://shop.hydraglosslips.com/cart/47999371739384:1" data-id="element-80" />
      <FAQ data-id="element-81" />

      {/* Final Close Section */}
      <section className="bg-brand-dark text-white py-20 px-4 text-center" data-id="element-82">
        <div className="max-w-2xl mx-auto" data-id="element-83">
          <h2 className="text-3xl font-bold mb-6" data-id="element-84">
            Tu primera venta no te cambia solo el bolsillo… <br data-id="element-85" />
            <span className="text-brand-pink" data-id="element-86">te cambia la cabeza.</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-87">
            Porque después de esa primera venta, ya no eres "una mamá que
            quiere". Eres una mamá que{' '}
            <span className="font-bold text-white" data-id="element-88">puede</span>.
          </p>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-brand-pink hover:bg-rose-400 text-brand-dark font-bold py-4 px-8 rounded-full text-xl transition-all transform hover:-translate-y-1" data-id="element-89">
            Descargar Mamá Digital 2.0 ahora
          </button>
        </div>
      </section>

      <Footer data-id="element-90" />
    </div>;
}